import { ConditionType } from "./condition-type";

export class Condition{
    ConditionType: ConditionType;
    ColumnName: string;
    Value: any;

    IsSatisfied(item: any){
        // if(!item[this.ColumnName] || item[this.ColumnName] == ''){
        // if(item[this.ColumnName]==null || item[this.ColumnName] == ''){
        if(item[this.ColumnName]==null || item[this.ColumnName].length === 0){
            return true;
        }

        switch(this.ConditionType){
            case ConditionType.Equals:{
                if(item[this.ColumnName] == this.Value){
                    return true;
                }
                return false;
            }
            case ConditionType.NotEqual:{
                if(item[this.ColumnName] != this.Value){
                    return true;
                }
                return false;
            }
            case ConditionType.GreaterThan:{
                if(item[this.ColumnName] > this.Value){
                    return true;
                }
                return false;
            }
            case ConditionType.LessThan:{
                if(item[this.ColumnName] < this.Value){
                    return true;
                }
                return false;
            }
            default: {
                return true;
            }
        }
    }

    LoadData(conditionData){
        let condition = new Condition();

        condition.ColumnName = conditionData && conditionData.columnName ? conditionData.columnName : '';
        condition.ConditionType = conditionData && conditionData.conditionType ? conditionData.conditionType : ConditionType.Equals;
        condition.Value = conditionData && conditionData.value ? conditionData.value : 0;

        return condition;
    }
}